import {createContext} from "react";

// Каталог открыт в модальном окне консультанта: карточки компактнее (наличие одной строкой)
export const CatalogInModal = createContext(false);
